import {
  ApartmentOutlined,
  BankOutlined,
  BarcodeOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  GiftOutlined,
  HeartOutlined,
  HomeOutlined,
  IdcardOutlined,
  LockOutlined,
  MailOutlined,
  PhoneOutlined,
  SafetyOutlined,
  SolutionOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Alert, Button, Col, Modal, Row, Select, Space } from "antd";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import { getAllMaster } from "../../redux/rtk/features/masters/masterSlice";
import {
  clearUser,
  loadSingleStaff,
} from "../../redux/rtk/features/user/userSlice";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";
import EmployeeTimeline from "../UI/EmployeeTimeline";
import EducaitonEditPopup from "../UI/PopUp/EducaitonEditPopup";
import ProfileEditPopup from "../UI/PopUp/ProfileEditPopup";

import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import getUserFromToken from "../../utils/getUserFromToken";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import resolveCompanyName from "../../utils/resolveCompanyName";
import { CompanyDetailsGetbyClient } from "../../redux/rtk/features/settingSlice/settingSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import EmployeeAward from "../UI/EmployeeAward";
import AddressEditPopup from "../UI/PopUp/addressEditPopup";
import AwardHistoryEditPopup from "../UI/PopUp/AwardHistoryEditPopup";
import BankDetailPopup from "../UI/PopUp/bankDetailPopup";
import ContactEditPopup from "../UI/PopUp/contactEditPoppup";
import EmployeeEditPopup from "../UI/PopUp/employeeEdit";
import DesignationEditPopup from "../UI/PopUp/DesignationEditPopup";
import EmployeeDesignation from "../UI/EmployeeDesignation";
import EmploymentEditPopup from "../UI/PopUp/EmploymentEditPopup";
import EmployeeEmploymentStatus from "../UI/EmployeementStatus";
import PaymentTypeStatus from "../UI/PaymentTypeStatus";
import PaymentTypePopup from "../UI/PopUp/PaymentTypePopup";
import ShiftDetailStatus from "../UI/ShiftHistory";

import WeeklyWorkingDaysStatus from "../UI/WeeklyWorkingDayStatus";
import ProvidentFundStatus from "../UI/ProvidentFundStatus";
import EsicStatus from "../UI/EsicStatus";
import ESICPopup from "../UI/PopUp/ESICPopup";
import ProvidentFundPopup from "../UI/PopUp/ProvidentFundPopup";
import WeeklyWorkingPopup from "../UI/PopUp/WeeklyWorkingPopup";
import ShiftPopup from "../UI/PopUp/ShiftPopupHistory";
import RoleHistoryStatus from "../UI/RoleHistoryData";
import RoleHistoryPopup from "../UI/PopUp/RoleHistoryPopup";
import ReportingHistoryStatus from "../UI/ReportingToHistory";
import ReportingManagerPopup from "../UI/PopUp/ReportingManagerPopup";
import QualificationsStatus from "../UI/EmployeeTimeline";
import CompanyHistoryStatus from "../UI/PopUp/CompanyHistoryStatus";
import CompanyHistoryPopup from "../UI/PopUp/CompanyHistoryPopup";
import LeavePolicyGroupStatus from "../UI/leavePolicyGroupStatus";
import LeavePolicyGroupPopup from "../UI/PopUp/leavePolicyGroupPopup";
import getRoleIdFromToken from "../../utils/getRoleIdByToken";
import EmployeeDepartment from "../UI/EmployeeDepartment";
import DepartmentEditPopup from "../UI/PopUp/DepartmentEditPopup";

dayjs.extend(weekday);
dayjs.extend(localeData);

const DetailStaff = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const RoleId = getRoleIdFromToken();
  const dispatch = useDispatch();
  const permissionsByRoleId = useSelector(
    (state) => state.permission.permissionByRole
  ); // update based on your slice
  const singleUser = useSelector((state) => state.users.user);
  const masterData = useSelector((state) => state.masters.masters);
  const clientCompanyData = useSelector((state) => state.setting.clientCompanyData);
  const user = singleUser?.EmployeesDetail
    ? singleUser.EmployeesDetail[0]
    : null;
  // console.log("user>>", user);
  const designationHistory =
    singleUser?.DesignationHistory?.length > 0
      ? singleUser.DesignationHistory
      : [];
  const departmentHistory =
    singleUser?.DepartmentHistory?.length > 0
      ? singleUser.DepartmentHistory
      : [];
  const employmentHistory =
    singleUser?.EmploymentHistory?.length > 0
      ? singleUser.EmploymentHistory
      : [];
  const paymentTypeHistory =
    singleUser?.PaymentTypeHistory?.length > 0
      ? singleUser.PaymentTypeHistory
      : [];
  const reportingHistory =
    singleUser?.ReportingHistory?.length > 0 ? singleUser.ReportingHistory : [];
  const shiftHistory =
    singleUser?.ShiftHistory?.length > 0 ? singleUser.ShiftHistory : [];
  const roleHistory =
    singleUser?.RoleHistory?.length > 0 ? singleUser.RoleHistory : [];
  const weeklyWorkingDaysHistory =
    singleUser?.WeeklyWorkingDaysHistory?.length > 0
      ? singleUser.WeeklyWorkingDaysHistory
      : [];
  const providentFundHistory =
    singleUser?.ProvidentFundHistory?.length > 0
      ? singleUser.ProvidentFundHistory
      : [];
  const esicHistory =
    singleUser?.EsicHistory?.length > 0 ? singleUser.EsicHistory : [];
  const qualificationsDetails =
    singleUser?.QualificationsDetails?.length > 0
      ? singleUser.QualificationsDetails
      : [];
  const companyOfficeHistory =
    singleUser?.CompanyOfficeHistory?.length > 0
      ? singleUser.CompanyOfficeHistory
      : [];
  const leavePolicyGroupHistory =
    singleUser?.LeavePolicyGroupHistory?.length > 0
      ? singleUser.LeavePolicyGroupHistory
      : [];

  const bankDetails =
    singleUser?.BankDetails?.length > 0
      ? singleUser.BankDetails.filter((item) => item.DataStatus === 1)
      : [];
  const accessToRoleId = 2;

  //  const permissions = useSelector((state) => state.permission.permission); // update based on your slice
  const findPermissionByKey = (permissionsByRoleId, key) => {
    for (const item of permissionsByRoleId) {
      if (item.MenuKey === key) return item;
      if (item.children) {
        const found = findPermissionByKey(item.children, key);
        if (found) return found;
      }
    }
    return null;
  };

  const permission = useSelector((state) =>
    findPermissionByKey(state.permission.permissionByRole, "users")
  );
  const permissions = useSelector((state) => state.permission.permission);
  // console.log("permissions", permission);
  // if (!permission?.DataView) return <p>You do not have access</p>;
  // console.log("permissionsByRoleId", permissionsByRoleId);

  const error = useSelector((state) => state.users.error);

  const { Option } = Select;
  const loginId = getUserFromToken();
  const [isModalVisible, setIsModalVisible] = useState(false);
  // console.log("loginId", loginId);
  // console.log("user?.EmployeeId", user?.EmployeeId);
  // // console.log(designation, "designation");
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onNavigateToDeletePage = () => {
    navigate("/admin/ProfileDelete");
  };
  const navigateToResetPassword = () => {
    navigate("/admin/resetPassword");
  };

  // Delete Supplier PopUp
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  useEffect(() => {
    dispatch(loadSingleStaff(id));
    dispatch(getAllMaster());
    dispatch(CompanyDetailsGetbyClient());
    return () => {
      dispatch(clearUser());
    };
  }, [dispatch, id]);

  const companyName = useMemo(
    () =>
      resolveCompanyName({
        user,
        masterData,
        clientCompanyData,
        tokenCompanyId: getCompanyIdFromToken(),
      }),
    [user, masterData, clientCompanyData]
  );

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }
  //  if (!permission?.DataView) {
  //   return <p>You do not have access</p>;
  // }

  const navigateToResignation = () => {
    navigate("/admin/resignation");
  };

  return (
    <div>
      <PageTitle title=" Back  " />

      {parseInt(id) === parseInt(loginId) && (
        <div className="mb-4">
          <Button
            type="default"
            danger
            icon={<UserDeleteOutlined />}
            onClick={navigateToResignation}
          >
            Resign
          </Button>
        </div>
      )}

      {/* {parseInt(loginId) === parseInt(user?.EmployeeId) && (
        <>
          <Button
            type="primary"
            onClick={() => setIsModalVisible(true)}
            className="ml-4 mb-4 mt-2"
          >
            Manage Account
          </Button>
          <Modal
            title="Account Actions"
            visible={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            footer={null}
          >
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Button
                type="default"
                icon={<LockOutlined />}
                onClick={navigateToResetPassword}
                block
              >
                Reset Password
              </Button>
            
            </Space>
          </Modal>
        </>
      )} */}

      {user ? (
        <div className="">
          <section>
            <div className="flex justify-between ant-card rounded h-auto mr-8"></div>
          </section>
          <Row
            className="mt-5"
            gutter={{
              xs: 8,
              sm: 16,
              md: 24,
              lg: 32,
              xl: 32,
            }}
          >
            {user && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between items-center">
                  <ProfileCardText className="text-start">
                    Personal Information
                  </ProfileCardText>
                  {/* <UserPrivateComponent permission={"update-user"}> */}
                  <ProfileEditPopup EmployeeId={user?.EmployeeId} user={user} />
                  {/* </UserPrivateComponent> */}
                </div>

                <Hr />

                <div className="m-5">
                  <ul className="space-y-4">
                    <li className="flex items-center">
                      <UserOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Full Name:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {[
                          user?.TitleTypeName,
                          user?.FirstName,
                          user?.MiddleName,
                          user?.LastName,
                        ]
                          .filter((part) => part && part.trim() !== "")
                          .join(" ")
                          .toUpperCase() || "Not Available"}
                      </p>
                    </li>

                    {/* Father's Name */}
                    <li className="flex items-center">
                      <UserOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Father's Name:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.FatherName &&
                        user.FatherName.trim().toLowerCase() !== "null"
                          ? user.FatherName
                          : "Not Available"}
                      </p>
                    </li>

                    {/* Phone Number */}
                    <li className="flex items-center">
                      <PhoneOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Phone:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.PhoneNumber &&
                        user.PhoneNumber.trim().toLowerCase() !== "null"
                          ? user.PhoneNumber
                          : "No Phone"}
                      </p>
                    </li>

                    {/* Alternate Number */}
                    <li className="flex items-center">
                      <PhoneOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Alternate Number:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.AlternateNumber || "No Alternate Number"}
                      </p>
                    </li>
                    {/* Email */}
                    <li className="flex items-center">
                      <MailOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Email:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.EmailId || "Not Available"}
                      </p>
                    </li>

                    {/* Blood Group */}
                    <li className="flex items-center">
                      <ThunderboltOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Blood Group:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.BloodGroupTypeName || "Not Available"}
                      </p>
                    </li>

                    {/* Birth Anniversary */}
                    <li className="flex items-center">
                      <GiftOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Birth Anniversary:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.BirthAnniversary
                          ? dayjs(user?.BirthAnniversary).format("DD/MM/YYYY")
                          : "Not Available"}
                      </p>
                    </li>

                    {/* Birthday */}
                    <li className="flex items-center">
                      <CalendarOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Birthday:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.BirthDate
                          ? dayjs(user?.BirthDate).format("DD/MM/YYYY")
                          : "Not Available"}
                      </p>
                    </li>

                    {/* Marital Status */}
                    <li className="flex items-center">
                      <HeartOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Marital Status:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.MaritalStatus ? "Married" : "Unmarried"}
                      </p>
                    </li>

                    {/* Marriage Anniversary */}
                    <li className="flex items-center">
                      <CalendarOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Marriage Anniversary:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.MarriageAnniversary
                          ? dayjs(user?.MarriageAnniversary).format(
                              "DD/MM/YYYY"
                            )
                          : "Not Available"}
                      </p>
                    </li>

                    {/* Gender */}
                    <li className="flex items-center">
                      <UserOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Gender:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.GenderTypeName || "Not Available"}
                      </p>
                    </li>

                    {/* PAN */}
                    <li className="flex items-center">
                      <IdcardOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">PAN:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.PanNumber || "Not Available"}
                      </p>
                    </li>

                    {/* Aadhaar */}
                    <li className="flex items-center">
                      <IdcardOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Aadhaar:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.AadharNumber || "Not Available"}
                      </p>
                    </li>
                  </ul>
                </div>
              </Col>
            )}
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="new-card rounded h-auto m-2"
            >
              <div className="flex justify-between items-center">
                <ProfileCardText className="text-start">
                  Contact Information
                </ProfileCardText>
                {/* <UserPrivateComponent permission={"update-user"}> */}
                <ContactEditPopup EmployeeId={user?.EmployeeId} user={user} />
                {/* </UserPrivateComponent> */}
              </div>

              <Hr />
              <div className="m-5">
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <UserOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">
                      Emergency Contact Person Name:
                    </span>
                    <p className="txt-color-secondary ml-2">
                      {user?.ContactPersonName &&
                      user.ContactPersonName.trim().toLowerCase() !== "null"
                        ? user.ContactPersonName
                        : "No Emergency Person Name"}
                    </p>
                  </li>

                  {/* Emergency Contact Number */}
                  <li className="flex items-center">
                    <PhoneOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">
                      Emergency Contact:
                    </span>
                    <p className="txt-color-secondary ml-2">
                      {user?.ContactPersonNumber || "No Emergency Contact"}
                    </p>
                  </li>
                  {/* Emergency Contact Number */}
                  <li className="flex items-center">
                    <PhoneOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">
                      Emergency Alternate Contact Number:
                    </span>
                    <p className="txt-color-secondary ml-2">
                      {user?.ContactPersonAlternateNumber ||
                        "No Emergency Alternate Contact"}
                    </p>
                  </li>
                  <li className="flex items-center">
                    <UserOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">
                      Emergency Contact Person Email:
                    </span>
                    <p className="txt-color-secondary ml-2">
                      {user?.ContactPersonEmailId || "No Emergency Contact"}
                    </p>
                  </li>

                  {/* Contact Person Relation */}
                  <li className="flex items-center">
                    <UserOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">
                      Contact Person Relation:
                    </span>
                    <p className="txt-color-secondary ml-2">
                      {user?.ContactPersonRelationName ||
                        "No Relation Provided"}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
            {user.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between items-center">
                  <ProfileCardText className="text-start">
                    Employee Information
                  </ProfileCardText>
                  {/* <UserPrivateComponent permission={"update-user"}> */}
                  {RoleId <= accessToRoleId && (
                    <EmployeeEditPopup
                      EmployeeId={user?.EmployeeId}
                      user={user}
                    />
                  )}
                  {/* </UserPrivateComponent> */}
                </div>
                <Hr />

                <div className="m-5">
                  <ul className="space-y-4">
                    <li className="flex items-center">
                      <IdcardOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Employee ID:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.EmployeeCode || "Not Available"}
                      </p>
                    </li>
                    <li className="flex items-center">
                      <IdcardOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Company Name:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {companyName}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <MailOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Official Mail:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.OfficialMailId || "Not Available"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <CalendarOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Join Date:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.JoinDate
                          ? dayjs(user?.JoinDate).format("DD/MM/YYYY")
                          : "Not Available"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <SafetyOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">ESIC:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.ESIC || "Not Available"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <TeamOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Employment Status:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.EmploymentTypeName || "No Employment Status"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <ApartmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Department:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.DepartmentName || "No Department"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <UserOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Reporting Manager:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {/* {user?.ReportingToName
                            ? `${user.reportingManager.firstName} ${user.reportingManager.lastName}`
                            : "Not Assigned"} */}
                        {user?.ReportingToName || "Not Assigned"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <UserOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Role:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.RoleName || "No Role"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <ClockCircleOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Shift:</span>
                      {/* <p className='txt-color-secondary ml-2'>
												{user?.shift?.name || "No Shift"} (
												{dayjs(user?.shift?.startTime).format("HH:MM")} -{" "}
												{dayjs(user?.shift?.endTime).format("HH:MM")})
											</p> */}
                      <p className="txt-color-secondary ml-2">
                        {user?.ShiftName || "No Shift"} (
                        {dayjs.utc(user?.ShiftStartTime).format("HH:mm")} -
                        {dayjs.utc(user?.ShiftEndTime).format("HH:mm")})
                      </p>
                    </li>

                    <li className="flex items-center">
                      <CalendarOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Working Week:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.WeeklyWorkingDaysName || "Not Available"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <SolutionOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        PF Eligibility:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.IsPfDeducted ? "Eligible" : "Not Eligible"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <BarcodeOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">UAN:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.UAN || "Not Available"}
                      </p>
                    </li>

                    <li className="flex items-center">
                      <DollarOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Payment Type:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.tbl_paymentType?.[0]?.paymentType ||
                          "Not Specified"}
                      </p>
                    </li>
                  </ul>
                </div>
              </Col>
            )}

            <Col
              xs={24}
              sm={12}
              md={12}
              lg={11}
              xl={11}
              className="new-card rounded h-auto m-2"
            >
              {/* <ProfileCardText className='text-start'>Address Details</ProfileCardText> */}
              <div className="flex justify-between items-center">
                <ProfileCardText className="text-start">
                  Address Details
                </ProfileCardText>
                {/* <UserPrivateComponent permission={"update-user"}> */}

                <AddressEditPopup EmployeeId={user?.EmployeeId} user={user} />

                {/* </UserPrivateComponent> */}
              </div>
              <Hr />

              <div className="m-5">
                <ul className="space-y-4">
                  {/* Current Address Heading */}
                  <li className="flex items-center">
                    <HomeOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-primary font-medium">
                      Current Address
                    </span>
                  </li>

                  {/* Current Address Fields */}
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">Address:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.CurrentStreetAddress &&
                      user.CurrentStreetAddress.trim().toLowerCase() !== "null"
                        ? user.CurrentStreetAddress
                        : "Not Available"}
                    </p>
                  </li>
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">City:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.CurrentCityName || "Not Available"}
                    </p>
                  </li>
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">State:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.CurrentStateName || "Not Available"}
                    </p>
                  </li>
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">Zip Code:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.CurrentZipCode || "Not Available"}
                    </p>
                  </li>
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">Country:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.CurrentCountryName || "Not Available"}
                    </p>
                  </li>

                  {/* Divider */}
                  <li>
                    <Hr />
                  </li>

                  {/* Permanent Address Heading */}
                  <li className="flex items-center">
                    <HomeOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-primary font-medium">
                      Permanent Address
                    </span>
                  </li>
                  {/* Permanent Address */}
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">Address:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.PermanentStreetAddress &&
                      user.PermanentStreetAddress.trim().toLowerCase() !==
                        "null"
                        ? user.PermanentStreetAddress
                        : "Not Available"}
                    </p>
                  </li>
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">City:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.PermanentCityName || "Not Available"}
                    </p>
                  </li>
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">State:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.PermanentStateName || "Not Available"}
                    </p>
                  </li>
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">Zip Code:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.PermanentZipCode || "Not Available"}
                    </p>
                  </li>
                  <li className="flex items-center">
                    <EnvironmentOutlined
                      className="mr-3"
                      style={{ fontSize: "15px" }}
                    />
                    <span className="txt-color-2 font-medium">Country:</span>
                    <p className="txt-color-secondary ml-2">
                      {user?.PermanentCountryName || "Not Available"}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
            {user.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Designation History
                  </ProfileCardText>

                  {/* <UserPrivateComponent
                      permission={"update-designationHistory"}
                    > */}
                  {/* {designationHistory && ( */}
                  {RoleId <= accessToRoleId && (
                    <DesignationEditPopup data={designationHistory} />
                  )}
                  {/* )} */}
                  {/* </UserPrivateComponent> */}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {designationHistory ? (
                    <EmployeeDesignation list={designationHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Designation History Found
                      </p>
                      <Alert
                        message="Not found , Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}

 {user.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Department History
                  </ProfileCardText>

                  {/* <UserPrivateComponent
                      permission={"update-designationHistory"}
                    > */}
                  {/* {departmentHistory && ( */}
                  {RoleId <= accessToRoleId && (
                    <DepartmentEditPopup data={departmentHistory} />
                  )}
                  {/* )} */}
                  {/* </UserPrivateComponent> */}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {departmentHistory?.length > 0 ? (
                    <EmployeeDepartment list={departmentHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Department History Found
                      </p>
                      <Alert
                        message="Not found , Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}
            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Employment Status History
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && (
                    <EmploymentEditPopup data={employmentHistory} />
                  )}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {employmentHistory ? (
                    <EmployeeEmploymentStatus list={employmentHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Employment Status History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}

            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Office History
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && (
                    <CompanyHistoryPopup data={companyOfficeHistory} />
                  )}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {companyOfficeHistory ? (
                    <CompanyHistoryStatus list={companyOfficeHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Office History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}

            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Payment Status History
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && (
                    <PaymentTypePopup data={paymentTypeHistory} />
                  )}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {paymentTypeHistory ? (
                    <PaymentTypeStatus list={paymentTypeHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Payment Status History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}

            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Reporting Manager History
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && (
                    <ReportingManagerPopup data={reportingHistory} />
                  )}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {reportingHistory ? (
                    <ReportingHistoryStatus list={reportingHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Reporting Manager History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}

            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Roles History
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && (
                    <RoleHistoryPopup data={roleHistory} />
                  )}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {roleHistory ? (
                    <RoleHistoryStatus list={roleHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Roles History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}

            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Shift History
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && (
                    <ShiftPopup data={shiftHistory} />
                  )}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {shiftHistory ? (
                    <ShiftDetailStatus list={shiftHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Shift History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}

            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Weekly Working Day History
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && (
                    <WeeklyWorkingPopup data={weeklyWorkingDaysHistory} />
                  )}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {weeklyWorkingDaysHistory ? (
                    <WeeklyWorkingDaysStatus list={weeklyWorkingDaysHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Shift History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}
            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Provident Fund
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && (
                    <ProvidentFundPopup data={providentFundHistory} />
                  )}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {providentFundHistory ? (
                    <ProvidentFundStatus list={providentFundHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No provident Fund History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}
            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    ESIC History
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && <ESICPopup data={esicHistory} />}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {esicHistory ? (
                    <EsicStatus list={esicHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Shift History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}
            {user.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={12}
                className="new-card rounded h-auto m-2 "
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Education History
                  </ProfileCardText>
                  {/* <UserPrivateComponent permission={"update-education"}> */}

                  {qualificationsDetails && RoleId <= accessToRoleId && (
                    <EducaitonEditPopup data={qualificationsDetails} />
                  )}
                  {/* </UserPrivateComponent> */}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {qualificationsDetails ? (
                    <QualificationsStatus list={qualificationsDetails} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Education History Found
                      </p>
                      <Alert
                        message="Not found , Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}
            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Leave Policy History
                  </ProfileCardText>
                  {RoleId <= accessToRoleId && (
                    <LeavePolicyGroupPopup data={leavePolicyGroupHistory} />
                  )}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {leavePolicyGroupHistory ? (
                    <LeavePolicyGroupStatus list={leavePolicyGroupHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Leave Policy History Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}
            {user.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2 "
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Salary History
                  </ProfileCardText>
                  {/* <UserPrivateComponent permission={"update-salaryHistory"}> */}
                  {/* {salaryHistory && (
                        <SalaryEditPopup data={salaryHistory} />
                      )} */}
                  {/* </UserPrivateComponent> */}
                </div>
                <Hr />
                {/* <div className="flex justify-start ml-10">
                    {salaryHistory?.length !== 0 ? (
                      <EmployeeSalary list={salaryHistory} />
                    ) : (
                      <div className="mb-10">
                        <p className="text-center mt-3 mb-3 ">
                          No Salary History Found
                        </p>
                        <Alert
                          message="Not found , Click on edit button to add new"
                          type="info"
                          showIcon
                        />
                      </div>
                    )}
                  </div> */}
              </Col>
            )}
            {/* Bank Details Section */}
            {user?.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Bank Details
                  </ProfileCardText>
                  <button className="mr-2 mt-2">
                    <BankDetailPopup data={bankDetails} />
                  </button>
                </div>
                <Hr />
                <div className="m-5">
                  {bankDetails.length > 0 ? (
                    <ul className="space-y-4">
                      {bankDetails.map((bank, index) => (
                        <li key={index} className="space-y-2">
                          <div className="flex items-center">
                            <BankOutlined
                              className="mr-3"
                              style={{ fontSize: "15px" }}
                            />
                            <span className="txt-color-2 font-medium">
                              Account Holder:
                            </span>
                            <p className="txt-color-secondary ml-2">
                              {bank.AccountHolderName || "N/A"}
                            </p>
                          </div>
                          <div className="flex items-center">
                            <BankOutlined
                              className="mr-3"
                              style={{ fontSize: "15px" }}
                            />
                            <span className="txt-color-2 font-medium">
                              Bank Name:
                            </span>
                            <p className="txt-color-secondary ml-2">
                              {bank.BankTypeName || "N/A"}
                            </p>
                          </div>
                          <div className="flex items-center">
                            <BankOutlined
                              className="mr-3"
                              style={{ fontSize: "15px" }}
                            />
                            <span className="txt-color-2 font-medium">
                              Account Number:
                            </span>
                            <p className="txt-color-secondary ml-2">
                              {bank.AccountNumber || "N/A"}
                            </p>
                          </div>
                          <div className="flex items-center">
                            <BankOutlined
                              className="mr-3"
                              style={{ fontSize: "15px" }}
                            />
                            <span className="txt-color-2 font-medium">
                              IFSC Code:
                            </span>
                            <p className="txt-color-secondary ml-2">
                              {bank.IfscCode || "N/A"}
                            </p>
                          </div>
                          <div className="flex items-center">
                            <BankOutlined
                              className="mr-3"
                              style={{ fontSize: "15px" }}
                            />
                            <span className="txt-color-2 font-medium">
                              Branch:
                            </span>
                            <p className="txt-color-secondary ml-2">
                              {bank.BranchName?.[0] || "N/A"}
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3">
                        No Bank Details Found
                      </p>
                      <Alert
                        message="Not found, Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}
            {/* Documents Section */}
            {/* <Col
								xs={24}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								className="new-card rounded h-auto m-2"
							> */}
            {/* <div className="flex justify-between">
									<ProfileCardText className="text-start">
										Update Document
									</ProfileCardText>
									<UserPrivateComponent permission={"update-user"}>
										<button onClick={showModal} aria-label="Edit Document Details">
											<BtnEditSvg size={30} />
										</button>
										<Modal
											title="Update Document Details"
											visible={isModalVisible}
											onCancel={handleCancel}
											footer={null}
											width={800}
										>
											<DocumentEditPopup />
										</Modal>
									</UserPrivateComponent>
								</div> */}
            {/* <Hr />
								<div className="m-5">
									{user?.documents && user.documents.length > 0 ? (
										<ul className="space-y-4">
											{user.documents.map((doc, index) => (
												<li key={doc.id} className="flex items-center">
													<FileOutlined className="mr-3" style={{ fontSize: "15px" }} />
													<p className="txt-color-secondary ml-2">
														{doc.documentType}
													</p>
													{doc.uploadFile && (
														<div className="ml-2">
															
															{doc.uploadFile.endsWith(".pdf") ? (
																<a
																	href={`http://93.127.198.13:2002/document-proof/${doc.uploadFile}`}
																	target="_blank"
																	rel="noopener noreferrer"
																	className="text-blue-500"
																>
																	View Document
																</a>
															) : (
																
																<img
																	src={`http://93.127.198.13:2002/document-proof/${doc.uploadFile}`}
																	alt={doc.documentType}
																	style={{ width: 100, height: 100, objectFit: "cover" }}
																/>
															)}
														</div>
													)}
												</li>
											))}
										</ul>
									) : (
										<div className="mb-10">
											<p className="text-center mt-3 mb-3">No Documents Found</p>
											<Alert
												message="Not found, Click on edit button to add new"
												type="info"
												showIcon
											/>
										</div>
									)}
								</div>
							</Col> */}

            {user.CompanyId && (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={12}
                className="new-card rounded h-auto m-2 "
              >
                <div className="flex justify-between">
                  <ProfileCardText className="text-start">
                    Award History
                  </ProfileCardText>

                  {/* <UserPrivateComponent permission={"update-awardHistory"}> */}
                  {user?.awardHistory && (
                    <AwardHistoryEditPopup data={user?.awardHistory} />
                  )}
                  {/* </UserPrivateComponent> */}
                </div>
                <Hr />
                <div className="flex justify-start ml-10">
                  {user?.awardHistory?.length !== 0 ? (
                    <EmployeeAward list={user?.awardHistory} />
                  ) : (
                    <div className="mb-10">
                      <p className="text-center mt-3 mb-3 ">
                        No Award History Found
                      </p>
                      <Alert
                        message="Not found , Click on edit button to add new"
                        type="info"
                        showIcon
                      />
                    </div>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </div>
      ) : (
        <div className="mt-10">
          {/* <Loader /> */}
          {error && <p className="text-center mt-3 mb-3">No Data Found</p>}
        </div>
      )}
      {/* </UserPrivateComponent> */}
    </div>
  );
};

const ProfileCardText = tw.div`
txt-color-2
text-xl
 text-center
  mt-5 `;

const Hr = tw.hr`
mt-3
mb-3
new-hr

`;

const Information = tw.div`
m-5
`;

export default DetailStaff;
